import { useState, useMemo } from "react";
import { groupBy as rowGrouper } from "lodash";

const useDataGrid = <T>(list: T[]) => {
  const [expandedGroupIds, setExpandedGroupIds] = useState<
    ReadonlySet<unknown>
  >(() => new Set<unknown>([]));

  const [sortColumns, setSortColumns] = useState<any[]>([]);

  const sortedRows = useMemo((): readonly T[] => {
    if (sortColumns.length === 0) return list;
    return [...list].sort((a, b) => {
      for (const sort of sortColumns) {
        const comparator = (a: any, b: any) =>
          a[sort.columnKey].localeCompare(b[sort.columnKey]);
        const compResult = comparator(a, b);
        if (compResult !== 0) {
          return sort.direction === "ASC" ? compResult : -compResult;
        }
      }
      return 0;
    });
  }, [list, sortColumns]);

  return {
    setSortColumns,
    sortedRows,
    expandedGroupIds,
    setExpandedGroupIds,
    rowGrouper,
    sortColumns,
  };
};

export default useDataGrid;
